export function buildPreservedParams(obj) {
  const usp = new URLSearchParams()
  for (const [k, v] of Object.entries(obj ?? {})) {
    if (v == null || v === "") continue
    if (Array.isArray(v)) {
      v.forEach((item) => {
        if (item != null && item !== "") usp.append(`${k}[]`, String(item))
      })
    } else {
      usp.set(k, String(v))
    }
  }
  return usp
}
